/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useState, useEffect, useCallback } from 'react'
import { PlayCircleOutlined, PauseCircleOutlined } from '@ant-design/icons'
import useWavesurfer from '@/hooks/useWavesurfer'
import styles from './index.module.less'

const WaveSurferPlayer = ({ options }) => {
  const containerRef = useRef(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const wavesurfer = useWavesurfer(containerRef, options)

  const onPlayClick = useCallback(() => {
    wavesurfer.isPlaying() ? wavesurfer.pause() : wavesurfer.play()
  }, [wavesurfer?.options])

  useEffect(() => {
    if (!wavesurfer) return

    console.log('wavesurfer =>', wavesurfer)
    setIsPlaying(false)

    const subscriptions = [
      wavesurfer.on('play', () => setIsPlaying(true)),
      wavesurfer.on('pause', () => setIsPlaying(false)),
      wavesurfer.on('ready', () => wavesurfer.play()),
    ]

    return () => {
      subscriptions.forEach(unsub => unsub())
    }
  }, [wavesurfer?.options])

  return (
    <div className={styles.wrap}>
      <div
        onClick={onPlayClick}
        className="text-2xl cursor-pointer"
        style={{ color: options.waveColor }}
      >
        {isPlaying ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
      </div>
      <div
        ref={containerRef}
        style={{ position: 'relative', minHeight: '100px' }}
      />
    </div>
  )
}

export default WaveSurferPlayer
